<template>
  <a
    :href="buildInternalLink(navItem)"
    :class="
      $b({
        withLogo: !!navItem.logo,
      })
    "
  >
    <div
      v-if="navItem.logo?.responsiveImage"
      :class="$b('logo')"
    >
      <DatoCmsImage
        :data="navItem.logo.responsiveImage"
        layout="fill"
        object-fit="contain"
        :object-position="`${navItem.logo.focalPoint.x * 100}% ${
          navItem.logo.focalPoint.y * 100
        }%`"
        sizes="(max-width: 600px) 150px, 200px"
      />
    </div>
    <span :class="$b('text')">
      {{ navItem.linkText }}
    </span>
  </a>
</template>
<script setup lang="ts">
import { Image as DatoCmsImage } from 'vue-datocms'
import type { ResponsiveImageType } from 'vue-datocms'
const { buildInternalLink } = useUrlBuilder()

interface Item {
  linkText: string
  internalLink: {
    slug: string
    _modelApiKey: string | undefined
    category: {
      slug: string | undefined
    }
  }
  internalLinkQueryParams: string | undefined
  logo: {
    responsiveImage: ResponsiveImageType
  }
}

interface Props {
  navItem: Item
}

defineOptions({
  name: 'MainNavLink',
})

defineProps<Props>()
</script>

<style lang="postcss">
.MainNavLink--with-logo {
  @apply flex items-center gap-x-4;

  @screen lg {
    @apply gap-x-3;
  }
}

.MainNavLink__logo {
  @apply aspect-square w-8 relative flex-shrink-0;
}

.MainNavLink__text {
  @apply relative whitespace-nowrap;

  &::before {
    @apply content-[''] absolute w-full h-[1px] -bottom-1
    bg-off-black
    scale-x-0 origin-right transition-transform duration-300;
  }
}

.MainNavLink:hover {
  .MainNavLink__text::before {
    @apply scale-x-100 origin-left;
  }
}
</style>
